import { defineStore } from 'pinia'

export const useStatusStore = defineStore('status', {
	state: () => ({
		pending: {
			user: false,
			redirect: false,
		},
		ready: {
			network: false,
			i18n: false,
			config: false,
			// AB-platform render gate (DEV-35179): variant-dependent content must not paint
			// before the experiment context resolves. Opened by src/modules/abPlatform.ts on
			// context ready / failure / a hard deadline (fail-open — a dead AB backend delays
			// the splash briefly, never hangs it), and immediately by the router guard on
			// routes with meta.skipExperiments.
			abPlatform: false,
		},
	}),

	getters: {
		resourceIsPending: (state) => (name) => {
			return state.pending[name]
		},

		networkResourceIsReady(state) {
			return state.ready.network
		},

		requiredResourcesAreReady(state) {
			const resources = ['i18n', 'network', 'config', 'abPlatform']
			return resources.every((name) => state.ready[name])
		},

		getResourceIsReady: (state) => (name) => {
			return state.ready[name]
		},
	},

	actions: {
		setResourcePending(name) {
			this.pending[name] = true
		},

		unsetResourcePending(name) {
			this.pending[name] = false
		},

		setResourceReadiness(name) {
			this.ready[name] = true
		},
	},
})
